export { ReadonlyModeEntryPoint } from './readonlyModeEntryPoint';
